import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  errorAlertContainer: {
    borderBottom: '1px solid',
    backgroundColor: theme.evPalette.rose[100],
    borderColor: theme.evPalette.rose[900],
    borderRadius: '0px',
    '& .myev-MuiSvgIcon-root': {
      color: theme.evPalette.rose[900],
    },
  },
}));
